export default __webpack_public_path__ + "static/up-d5673034d1d8ca6b8592e7fa06e448e1.png";